var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _path10, _path11, _path12, _path13, _path14, _polygon, _path15, _path16, _path17, _path18, _polygon2, _polygon3, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 500",
    style: {
      enableBackground: "new 0 0 700 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B6BE34;}\n\t.st1{fill:none;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:url(#SVGID_2_);}\n\t.st4{fill:url(#SVGID_3_);}\n\t.st5{fill:url(#SVGID_4_);}\n\t.st6{fill:url(#SVGID_5_);}\n\t.st7{fill:url(#SVGID_6_);}\n\t.st8{fill:url(#SVGID_7_);}\n\t.st9{fill:url(#SVGID_8_);}\n\t.st10{fill:url(#SVGID_9_);}\n\t.st11{fill:url(#SVGID_10_);}\n\t.st12{fill:#FFFFFF;}\n\t.st13{opacity:0.2;fill:#FFFFFF;}\n\t.st14{fill:#1DBBBE;}\n\t.st15{opacity:0.1;fill:url(#SVGID_11_);}\n\t.st16{fill:#326AB2;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M574,200.6v-3.3v-11.6v-21.5h0c0-18.2-16.9-33-37.7-33c-20.8,0-37.7,14.8-37.7,33v21.5v11.5v3.2 c-1.2,1-2,2.5-2,4.2c0,0.2,0,0.3,0.1,0.5c0.3,2.8,2.6,4.9,5.4,4.9c2.8,0,5.1-2.2,5.4-4.9c0-0.2,0.1-0.3,0.1-0.5c0-1.6-0.7-3-1.8-4 v-3.3v-11.6v-21.5c0-14.8,13.7-26.8,30.6-26.8c16.9,0,30.6,12,30.6,26.8v21.5v11.6v3.2c-1.2,1-2,2.5-2,4.2c0,0.2,0,0.3,0.1,0.5 c0.3,2.8,2.6,4.9,5.4,4.9s5.1-2.2,5.4-4.9c0-0.2,0.1-0.3,0.1-0.5C575.9,203,575.2,201.6,574,200.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M550,261.4c-0.1,0.2-0.3,0.3-0.4,0.5C549.7,261.7,549.9,261.6,550,261.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 527.3403,
    y1: 133.1681,
    x2: 527.3403,
    y2: 289.697
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1DBBBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1754,
    style: {
      stopColor: "#169CA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4181,
    style: {
      stopColor: "#0D778D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6441,
    style: {
      stopColor: "#075C7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8448,
    style: {
      stopColor: "#034C6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    style: {
      stopColor: "#02466A"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M584,185.7h-7.3l0,13.7c1.2,1.4,1.9,3.2,1.9,5.2c0,4.5-3.7,8.2-8.2,8.2s-8.2-3.7-8.2-8.2c0-2,0.7-3.9,2-5.3 v-13.6h-55.8v13.8c1.1,1.4,1.8,3.2,1.8,5.1c0,4.5-3.7,8.2-8.2,8.2c-4.5,0-8.2-3.7-8.2-8.2c0-2.1,0.8-3.9,2-5.4v-13.6h-7.4 c-5.6,0-10.3,4.2-11,9.8l-13.6,112.9c-0.2,1.2-0.1,2.5,0.2,3.6c4.3-1,8.5-2.1,12.5-3.4c2.7-0.8,5.3-1.7,7.9-2.7 c3.9-1.4,7.6-2.9,11.2-4.6c1.2-0.5,2.4-1.1,3.6-1.7c2.3-1.1,4.6-2.3,6.9-3.5c0.7-0.4,1.3-0.7,2-1.1c-1.6-2.6-2.8-4.7-3.9-6.7 c-1.2-2.2-2.3-5.2-0.3-7.1c0.9-0.8,2-1.3,3.3-1.3c1.2,0,2.4,0.5,3.2,1.3l0.1,0.1l6.8,8c0.1-0.1,0.3-0.2,0.4-0.3 c0.7-0.4,1.3-0.9,2-1.3c1.1-0.7,2.2-1.5,3.3-2.3c1.5-1.1,3.1-2.2,4.5-3.4c0.1-0.1,0.3-0.2,0.4-0.3l0.5-37.2c0-2.6,2.1-4.7,4.6-4.7 c1.3,0,2.5,0.5,3.3,1.4c0.9,0.9,1.3,2.1,1.3,3.4l-0.4,29.2c1.6-1.4,3.1-2.8,4.6-4.3l0-3.4c0-2.6,2.1-4.7,4.6-4.7 c0.9,0,1.7,0.3,2.4,0.7c0.2-0.2,0.4-0.4,0.6-0.7c0.1-0.2,0.3-0.3,0.4-0.5c1.3-1.5,2.7-3,3.9-4.5c1.2-1.4,2.4-2.9,3.5-4.3 c0.9-1.2,1.8-2.4,2.7-3.5c3.2-4.3,6.2-8.7,8.9-12.9c0.4-0.6,0.7-1.2,1.1-1.8c0.6-0.9,1.1-1.9,1.7-2.8c0.4-0.6,0.8-1.3,1.1-1.9 c1.8-3.1,3.5-6.2,5-9.2c0.4-0.7,0.7-1.5,1.1-2.2c0.3-0.7,0.7-1.4,1-2.1c0.4-0.7,0.7-1.5,1-2.2c0.3-0.6,0.6-1.3,0.9-1.9 c0.3-0.7,0.7-1.5,1-2.2c4.1-9.5,6.6-17.2,8-21.7C589,186.6,586.6,185.7,584,185.7z M533,230.7c-2.5,0-4.9,0.9-6.7,2.6 c-3.3,3-4.1,7.9-2,11.8l0.1,0.3v7.2l-2.1-2.2c-2.6-2.8-4-6.6-3.8-10.4c0.2-3.9,1.8-7.5,4.7-10.1c2.7-2.5,6.2-3.8,9.8-3.8 c4.1,0,7.9,1.7,10.7,4.7c5.1,5.5,5.2,13.9,0.2,19.5l-2,2.3v-7.5l0.1-0.2c1.7-3.6,1-7.9-1.7-10.8C538.4,231.8,535.8,230.7,533,230.7 z M548.1,257c-1.3,1.2-2.8,2.3-4.6,3.2l-1.7,0.9v-5.2l0.5-0.3c1-0.6,1.8-1.2,2.6-1.9c3.5-3.2,5.5-7.6,5.7-12.3 c0.2-4.7-1.5-9.2-4.7-12.7c-3.3-3.6-8.1-5.7-13-5.7c-4.5,0-8.7,1.7-12,4.7c-3.5,3.2-5.5,7.6-5.7,12.3c-0.2,4.7,1.5,9.2,4.7,12.7 c1,1.1,2.3,2.1,3.8,3l0.6,0.3v5.2l-1.7-0.9c-2.3-1.2-4.4-2.7-6.1-4.6c-4-4.4-6.1-10.1-5.9-16c0.2-6,2.8-11.5,7.2-15.5 c4.1-3.8,9.5-5.9,15.1-5.9c6.2,0,12.2,2.6,16.4,7.2c4,4.4,6.1,10.1,5.9,16C555.1,247.4,552.5,252.9,548.1,257z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 522.6131,
    y1: 129.808,
    x2: 522.6131,
    y2: 345.3819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1DBBBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1754,
    style: {
      stopColor: "#169CA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4181,
    style: {
      stopColor: "#0D778D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6441,
    style: {
      stopColor: "#075C7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8448,
    style: {
      stopColor: "#034C6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    style: {
      stopColor: "#02466A"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M523,285.7c-1.1,0.8-2.2,1.5-3.3,2.3c-0.7,0.5-1.3,0.9-2,1.3c-0.1,0.1-0.3,0.2-0.4,0.3l6.5,7.6 c0.4,0.5,1.1,0.8,1.7,0.8c0.3,0,0.5,0,0.8-0.1c0.9-0.3,1.5-1.2,1.5-2.1l0.2-13.8c-0.1,0.1-0.3,0.2-0.4,0.3 C526.1,283.4,524.5,284.5,523,285.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 548.9972,
    y1: 254.4513,
    x2: 608.7614,
    y2: 254.4513
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1DBBBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1754,
    style: {
      stopColor: "#169CA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4181,
    style: {
      stopColor: "#0D778D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6441,
    style: {
      stopColor: "#075C7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8448,
    style: {
      stopColor: "#034C6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    style: {
      stopColor: "#02466A"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M608.7,308.4l-9.8-80.9l-3.9-32c-0.4-3-1.9-5.6-4.2-7.4v0l0,0c-1.3,4.5-3.8,12.2-8,21.7 c-0.3,0.7-0.6,1.5-1,2.2c-0.3,0.6-0.6,1.2-0.9,1.9c-0.3,0.7-0.7,1.5-1,2.2c-0.3,0.7-0.7,1.4-1,2.1c-0.4,0.7-0.7,1.4-1.1,2.2 c-1.5,3-3.2,6.1-5,9.2c-0.4,0.6-0.7,1.3-1.1,1.9c-0.6,0.9-1.1,1.9-1.7,2.8c-0.4,0.6-0.7,1.2-1.1,1.8c-2.7,4.2-5.6,8.6-8.9,12.9 c-0.9,1.2-1.8,2.4-2.7,3.5c-1.1,1.4-2.3,2.9-3.5,4.3c-1.3,1.5-2.6,3-3.9,4.5c-0.1,0.2-0.3,0.3-0.4,0.5c-0.2,0.2-0.4,0.4-0.6,0.7 c0,0,0.1,0,0.1,0c1.4,0.9,2.2,2.4,2.1,4l-0.2,16c0,1.2,1,2.3,2.2,2.3c1.3,0,2.3-1,2.3-2.2l0.2-11.4c0-2.6,2.1-4.7,4.6-4.7 c1.3,0,2.5,0.5,3.3,1.4c0.9,0.9,1.3,2.1,1.3,3.4l-0.2,16c0,1.2,1,2.3,2.2,2.3c1.3,0,2.3-1,2.3-2.2l0.1-10.3c0-2.6,2.1-4.7,4.6-4.7 c1.3,0,2.5,0.5,3.3,1.4c0.9,0.9,1.3,2.1,1.3,3.4l-0.3,24.1c-0.1,4.1-2.2,12.7-4.1,19.4h23.4C604.3,320.8,609.5,315,608.7,308.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 493.9262,
    y1: 129.8081,
    x2: 493.9262,
    y2: 345.3814
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1DBBBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1754,
    style: {
      stopColor: "#169CA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4181,
    style: {
      stopColor: "#0D778D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6441,
    style: {
      stopColor: "#075C7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8448,
    style: {
      stopColor: "#034C6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    style: {
      stopColor: "#02466A"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M516,308.1c-2.4-3.8-5.1-8.1-7.8-12.5c-0.1-0.1-0.1-0.2-0.2-0.4c-0.7,0.4-1.3,0.7-2,1.1 c-2.2,1.2-4.5,2.4-6.9,3.5c-1.2,0.6-2.4,1.1-3.6,1.7c-3.6,1.6-7.3,3.1-11.2,4.6c-2.6,0.9-5.2,1.8-7.9,2.7c-4,1.3-8.2,2.4-12.5,3.4 c1,5,5.5,8.8,10.9,8.8h21.6h27.3c-0.1-0.3-0.3-0.5-0.4-0.7C521.4,316.6,518.8,312.4,516,308.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 539.5889,
    y1: 129.8074,
    x2: 539.5889,
    y2: 345.3733
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1DBBBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1754,
    style: {
      stopColor: "#169CA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4181,
    style: {
      stopColor: "#0D778D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6441,
    style: {
      stopColor: "#075C7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8448,
    style: {
      stopColor: "#034C6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    style: {
      stopColor: "#02466A"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M537.3,277.8c0,1.2,1,2.3,2.2,2.3c1.3,0,2.3-1,2.3-2.2l0.1-8c-1.5,1.4-3,2.9-4.6,4.3L537.3,277.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 549.2983,
    y1: 133.1669,
    x2: 549.2983,
    y2: 289.6974
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    style: {
      stopColor: "#8DC340"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#026938"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M549,262.5c0.2-0.2,0.4-0.4,0.6-0.7C549.4,262.1,549.2,262.3,549,262.5L549,262.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 549.2983,
    y1: 129.8067,
    x2: 549.2983,
    y2: 345.3822
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3076,
    style: {
      stopColor: "#8DC340"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#026938"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M549,262.5c0.2-0.2,0.4-0.4,0.6-0.7C549.4,262.1,549.2,262.3,549,262.5L549,262.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 404.9691,
    y1: 276.4862,
    x2: 432.7259,
    y2: 276.4862
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00052083,
    style: {
      stopColor: "#79B9E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#463E97"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 405,
    y: 240.2,
    className: "st9",
    width: 27.8,
    height: 72.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M295.4,285.4c-4.3,0-8.1,2.7-7.3,8.9c14.7,0,29.4,0,44.1,0l11.3-9C327.5,285.3,311.5,285.3,295.4,285.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.4007,
    y1: 272.8254,
    x2: 116.5788,
    y2: 272.8254
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1DBBBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1754,
    style: {
      stopColor: "#169CA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4181,
    style: {
      stopColor: "#0D778D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6441,
    style: {
      stopColor: "#075C7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8448,
    style: {
      stopColor: "#034C6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    style: {
      stopColor: "#02466A"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M116.6,260.4c-6.5,0-12.8,0-19.2,0c0,8.3,0,16.5,0,24.9c5,0,9.8,0,14.5,0 C111.2,276.4,113.2,268.3,116.6,260.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 195.2692,
    y1: 308.5576,
    x2: 210.4395,
    y2: 308.5576
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1DBBBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1754,
    style: {
      stopColor: "#169CA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4181,
    style: {
      stopColor: "#0D778D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6441,
    style: {
      stopColor: "#075C7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8448,
    style: {
      stopColor: "#034C6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    style: {
      stopColor: "#02466A"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M206.9,305.8c-2.8-1.8-5.8-1.7-8.3,0.2c-1.8,1.4-2.9,3.6-3.3,6.6h15.2C210.4,309.6,209.3,307.3,206.9,305.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M208.5,303.3c-1.8-1.2-3.8-1.7-5.7-1.7c-2.1,0-4.2,0.7-6,2.1c-2.6,2-4.1,5-4.5,9.1c0.5,0,1,0,1.5,0 c0.4-3.2,1.5-6.1,3.9-7.9c3.1-2.4,6.8-2.3,10-0.3c2.8,1.8,4.2,4.6,4.2,8.2c0.5,0,1,0,1.5,0C213.4,308.6,211.7,305.3,208.5,303.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M207.7,304.6c-3.2-2-6.9-2.1-10,0.3c-2.4,1.9-3.6,4.7-3.9,7.9c6,0,12.1,0,18.1,0 C211.9,309.2,210.5,306.3,207.7,304.6z M198.6,306c2.5-1.9,5.5-2,8.3-0.2c2.3,1.5,3.5,3.7,3.5,6.8h-15.2 C195.7,309.6,196.8,307.4,198.6,306z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "406.7,216.3 406.7,234.8 407.2,234.8 430.5,216.3  "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M373.5,294.3c-0.3-2.2-1.1-4-2.1-5.7c-1.1-1.8-2.6-3.2-4.6-3.2c-7.7,0-15.5,0-23.2,0l-11.3,9 C346,294.3,359.7,294.3,373.5,294.3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M395.8,287.6c0.1-5.6-1.2-10.6-3.8-15.4c-3.9-7.4-9.5-11.3-16.7-12.1c-0.7-0.1-1.5-0.1-2.3-0.1 c-23.9-0.1-47.7-0.1-71.6,0c-2.1,0-4.2,0.3-6.2,0.9c-3.6,1.1-6.3,3.5-8.5,7.4v-28.1h-22.9v54.1h-13.5v-54.1h-22v54.1h-14.5V260 h-21.7v34.3h-12.4c-1-4-2-7.8-3.9-11.3c-1.3-2.4-2.8-4.6-4.3-6.8c-2.6-3.6-5.6-6.5-9-9c-4.3-3.1-9-5.3-14-6.5 c-3.8-0.9-7.6-1.1-11.5-0.5c-0.4,0.1-0.7,0.3-0.7,0.7c-0.7,3.6-1.4,7.3-1.6,11c-0.2,4.5,0.4,8.9,1.8,13.3c1.5,0,3.2-0.1,4.8,0 c1.6,0.1,3.3,0,4.9,0.3c4.2,0.7,7.2,3.8,7.6,8.7h-15.5c-0.8-1.5-1.8-2.8-2.3-4.4c-2.2-5.8-3.4-11.7-3-18c0.3-5.3,1.2-10.3,2.9-15.1 c1.2-3.3,2.7-6.4,4.9-9c1.8-2.1,4-3.7,6.5-4.9c0.8-0.4,1.8-0.8,2-2c-0.6-0.6-1.2-0.7-2-0.8c-1.1-0.1-2,0.3-3.1,0.4 c-3.6,0.5-7.1,1.6-10.3,3.4c-5.3,3-9.6,7.3-13.1,12.7c-4.7,7.1-7.1,15.1-7.5,23.8c-0.2,4.7,0.4,9.4,1.5,14H86.6v-54.1H65.1v72.5 h127.2c0.4-4.1,1.9-7.1,4.5-9.1c1.8-1.4,3.9-2.1,6-2.1c1.9,0,3.9,0.6,5.7,1.7c3.2,2,4.9,5.3,4.9,9.4h182.4 C395.8,304.3,395.7,295.9,395.8,287.6z M288.1,294.3c-0.7-6.2,3-8.9,7.3-8.9c16-0.1,32.1-0.1,48.1-0.1c7.7,0,15.5,0,23.2,0 c2,0,3.5,1.4,4.6,3.2c1.1,1.7,1.8,3.6,2.1,5.7H288.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 309.0341,
    y1: 286.3286,
    x2: 395.819,
    y2: 286.3286
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005210951,
    style: {
      stopColor: "#1DBBBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#02466A"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M395.8,287.5c0.1-5.6-1.2-10.6-3.8-15.4c-3.9-7.4-9.5-11.3-16.7-12.1l-31.8,25.2c7.7,0,15.5,0,23.2,0 c2,0,3.5,1.4,4.6,3.2c1.1,1.7,1.8,3.6,2.1,5.7c-13.7,0-27.5,0-41.2,0L309,312.7c28.9,0,57.8,0,86.8,0 C395.8,304.2,395.7,295.8,395.8,287.5z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M432.6,262.3c0-7.3,0-14.7,0-22.1H405v72.5h28.1C432.5,295.8,432.5,278.8,432.6,262.3z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "431,216.3 430.5,216.3 407.2,234.8 431,234.8  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "431,216.3 430.5,216.3 407.2,234.8 431,234.8  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M432.7,236.5H405v-22h27.8V236.5z M406.5,235h24.7v-18.9h-24.7V235z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M422,220.6c-0.3,0.7-0.8,1.1-1.6,1.5c-0.7,0.3-1.4,0.8-1.9,1.6c0.4,0.5,1,0.8,1.7,1c0.7,0.2,1.4,0.5,2,0.8 c0.6,0.4,1,1,1,1.7c0,0.4-0.1,0.8-0.3,1.3c-0.5,1.3-1.5,2.4-2.8,3.4c-1.1,0.8-2.3,1.3-3.6,1.5c-1.2,0.2-2.5,0.4-3.8,0.6 c1.1-0.5,2.2-1,3.4-1.5c1.2-0.5,2.3-1,3.3-1.6c0.3-0.2,0.5-0.4,0.5-0.6c0-0.1,0-0.1-0.1-0.2c-0.4-0.2-0.9-0.5-1.4-0.7 c-0.5-0.2-1-0.5-1.4-0.7c-0.9-0.5-1.3-1.1-1.3-2c0-0.9,0.5-2,1.6-3.4c2-2.6,3.5-4.2,4.4-5c0.4-0.3,1-0.7,1.9-1L422,220.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.7c6f1f875207d6e4c75af60b0bb7e2ff.svg";
export { ForwardRef as ReactComponent };